<div class="dashboard-color-picker" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="20px">
  <div (click)="toggleColors()" fxLayout="row" fxLayoutAlign=" center">
    <mat-icon>palette</mat-icon>
    <mat-label> Select color of study </mat-label>
    <div class="circle" *ngIf="color" [ngStyle]="{ background: color }"></div>
  </div>

  <div *ngIf="show" fxLayout="row" fxLayoutAlign="space-evenly">
    <div
      class="circle"
      *ngFor="let paint of defaultColors"
      [ngStyle]="{ background: paint }"
      (click)="changeColor(paint)"
    ></div>
  </div>
</div>
